module.exports = __webpack_public_path__ + "img/gb9115_6.prt.f91df5ab.jpg";